import Axios from "axios";
import { Message } from "element-ui";
import {
  clientId,
  loginCallback,
  oauthUrl,
  requestUrl,
  scope,
} from "../config/config";
import qs from "querystring";

let showMes = true;

const instance = Axios.create({
  baseURL: requestUrl,
  timeout: 30000,
});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    config.data = JSON.stringify(config.data);
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
      // 'Authorization':'Bearer '+ sessionStorage.getItem('token')
    };
    if (config.url === "/sys/works/excel") {
      config.timeout = 0;
    }
    if (sessionStorage.getItem("token")) {
      config.headers.Authorization =
        "Bearer " + sessionStorage.getItem("token");
    }
    // config.auth={
    //     username: 'user',
    //     password: '123456'
    // };
    let newData = config.params;
    for (let key in newData) {
      if (newData[key] === "") {
        delete newData[key];
      }
    }
    config.params = newData;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.status == 304) {
      sessionStorage.clear();
      window.location.reload();
    } else {
      return response;
    }
  },
  (err) => {
    if (err.code === "ECONNABORTED" || err.message === "Network Error") {
      if (showMes) {
        Message({
          showClose: true,
          message: "网络连接超时",
          type: "error",
          center: true,
          duration: 3000,
        });
      }
      showMes = false;
      return Promise.reject(err.response);
    }
    if (err.response.status === 401) {
      // setTimeout(function(){
      sessionStorage.clear();
      //     window.location.reload()
      // },1500);
      sessionStorage.setItem(
        "jumpRouter",
        window.location.pathname + window.location.search
      );
      setTimeout(function() {
        window.location =
          oauthUrl +
          "/oauth/authorize?" +
          encodeURI(
            "client_id=" +
              clientId +
              "&response_type=token&state=5ca75bd30&scope=" +
              scope +
              "&redirect_uri=" +
              loginCallback
          );
      }, 1500);
      if (showMes) {
        Message({
          showClose: true,
          message: "登录超时，请重新登录。",
          type: "error",
          center: true,
          duration: 1500,
        });
      }
      showMes = false;
      return false;
    } else {
      showMes = true;
      if (err.response.status === 403) {
        Message({
          showClose: true,
          message: "当前账号没有权限",
          type: "error",
          center: true,
          duration: 3000,
        });
      } else if (err.response.status === 500) {
        Message({
          showClose: true,
          message: err.response.data,
          type: "error",
          center: true,
          duration: 3000,
        });
      } else if (err.response.status === 502) {
        Message({
          showClose: true,
          message: "服务器异常",
          type: "error",
          center: true,
          duration: 3000,
        });
      }
      return Promise.reject(err.response);
    }
  }
);
export default {
  post(url, params = {}) {
    return new Promise((resolve, reject) => {
      instance.post(url, params).then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  get(url, params = {}) {
    return new Promise((resolve, reject) => {
      instance
        .get(url, { params: params })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  put(url, params = {}) {
    return new Promise((resolve, reject) => {
      instance
        .put(url, params)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delete(url, params = {}) {
    return new Promise((resolve, reject) => {
      instance
        .delete(url, { data: params })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
